/* ORTEVA — hafif tema betiği */
(function () {
  'use strict';

  // Sayfa içi yumuşak kaydırma: [data-bm-kaydir="#hedef"]
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-bm-kaydir]') : null;
    if (!t) return;
    var sec = document.querySelector(t.getAttribute('data-bm-kaydir'));
    if (!sec) return; // hedef yoksa bağlantı normal şekilde ürün sayfasına gider
    e.preventDefault();
    var mnav = document.getElementById('bm-nav');
    if (mnav) mnav.classList.remove('bm-nav--acik'); // mobil menüyü kapat
    var y = sec.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  });

  // Mobil menü
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-bm-menu]') : null;
    if (!b) return;
    var nav = document.getElementById('bm-nav');
    if (nav) nav.classList.toggle('bm-nav--acik');
  });

  // Sepet adedini canlı güncelle (AJAX ekleme sonrası)
  window.bmSepetSayisi = function (n) {
    document.querySelectorAll('[data-bm-sepet-sayi]').forEach(function (el) {
      el.textContent = n;
    });
  };
})();
